export const Platform_Name = 'Ocula Finance'